<template>
  <v-dialog v-model="dialog" width="800" :retain-focus="false">
    <v-card>
      <v-card-title class="headline">
        Dodaj niedostępność
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-autocomplete
                  v-model="form.company"
                  :items="partners"
                  item-text="name"
                  item-value="plcId"
                  label="Firma"
                  :rules="formRules.company"
                  @change="loadBranches"
                  clearable
                  placeholder="Firma"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" align-self="start" dense v-if="form.company">
              <v-select
                  multiple
                  v-model="form.branches"
                  :items="branches"
                  item-text="name"
                  item-value="id"
                  label="Oddziały"
                  :rules="formRules.branches"
                  required
              ></v-select>
            </v-col>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-select
                  multiple
                  v-model="form.serviceTypes"
                  :items="serviceTypes"
                  item-text="name"
                  item-value="id"
                  label="Typ"
                  :rules="formRules.serviceTypes"
              ></v-select>

              <p class="mt-2">Przedziały czasowe
                <v-icon size="24" right @click="addPeriod">
                  mdi-plus
                </v-icon>
              </p>
              <div v-if="form.periods.length === 0" class="red--text">
                Dodaj przynajmniej jeden przedział czasowy.
              </div>
              <div v-for="(period, key) in form.periods" :key="period">
                <p class="font-weight-bold">Przedział {{ key + 1 }}
                  <v-icon size="24" right @click="removePeriod(key)">
                    mdi-minus
                  </v-icon>
                </p>
                <v-row>
                  <v-col>
                    <v-menu
                        v-model="menu[key]['from']"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="period.from"
                            label="Od"
                            prepend-icon="mdi-calendar-blank"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="formRules.required"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="period.from"
                          :first-day-of-week="1"
                          @input="menu[key]['from'] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                        v-model="menu[key]['to']"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="period.to"
                            label="Od"
                            prepend-icon="mdi-calendar-blank"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="formRules.required"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="period.to"
                          :first-day-of-week="1"
                          @input="menu[key]['to'] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
                :disabled="!valid || form.periods.length === 0 || form.periods.some(period => !period.from || !period.to)"
            >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'
import units from "@/mixins/unitMixin";
import locationTypeMixin from "@/mixins/locationTypeMixin";
import transmissionTypeMixin from "@/mixins/transmissionTypeMixin";
import fuelTypeMixin from "@/mixins/fuelTypeMixin";

export default {
  name: 'ModalAddCalendarEvent',
  mixins: [
    locationTypeMixin,
    transmissionTypeMixin,
    fuelTypeMixin,
    transactionTypeMixin,
    transportConditionMixin,
    categoryMixin,
    priceMixin,
    paymentConditionMixin,
    dateMixin,
    validationHelpers,
    units
  ],
  created() {
    this.loadPartners();
    this.getServiceTypes();
  },
  data() {
    return {
      valid: false,
      menu: [],
      partners: [],
      branches: [],
      serviceTypes: [],
      dialog: false,
      form: {
        company: null,
        branches: [],
        serviceTypes: [],
        type: 'NOT_AVAILABLE',
        periods: [],
      },
      formRules: {
        company: [(value) => !!value || 'wybierz firmę'],
        type: [(value) => !!value || 'wybierz typ'],
        branches: [(value) => value.length !== 0 || 'wybierz oddział'],
        serviceTypes: [(value) => value.length !== 0 || 'wybierz typ'],
        periods: [(value) => value.length !== 0 || 'dodaj przynajmniej jeden przedził czasowy'],
        required: [(value) => !!value || 'pole wymagane'],
      },
    }
  },
  methods: {
    open() {
      this.dialog = true
      this.form = {
        company: null,
        branches: [],
        serviceTypes: [],
        type: 'NOT_AVAILABLE',
        periods: [],
      }
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const event = {
        company: this.form.company,
        type: this.form.type,
        branches: this.form.branches,
        serviceTypes: this.form.serviceTypes,
        periods: this.form.periods,
      }
      api
          .post('/api/calendar/events', event)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Dodano niedostępność.',
            });
            this.dialog = false;
            this.$parent.reload();
          })
          .catch((error) => {
            console.error('Error when adding a event:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    getServiceTypes() {
      api
          .get('/api/categories/212/service/nested')
          .then((response) => {
            this.serviceTypes = [{ id: 'all', name: 'Wszystkie' }];

            response.data.services.forEach(service => {
              service.name = service.name + ' - ' + service.category;
              this.serviceTypes.push(service);
            });
          })
          .catch((error) => {
            console.error('Error when getting a service types:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    async loadPartners() {
      api
          .get('/api/companies?partner=true')
          .then((data) => {
            this.partners = [{plcId: null, name: 'Wybierz'}];
            this.partners = this.partners.concat(data.data.items);
          })
          .catch((error) => {
            console.error('Error when loading partners: ', error);
          })
    },
    loadBranches() {
      api
          .get('/api/price-list/company-branch?companyId=' + this.form.company)
          .then((data) => {
            this.branches = [{plcId: 'all', id: 'all', name: 'Wszystkie'}];

            this.branches = this.branches.concat(data.data.items);
          })
          .catch((error) => {
            console.error('Error when loading branches: ', error);
          })
    },
    addPeriod() {
      this.form.periods.push({
        from: null,
        to: null,
      });

      this.menu.push({
        from: false,
        to: false,
      });
    },
    removePeriod(index) {
      this.form.periods.splice(index, 1);

      this.menu.splice(index, 1);
    },
  },
}
</script>

<style scoped></style>
